const navConfig = {
  navLinks: [
    { id: 0, label: 'Home', path: '/' },
    { id: 1, label: 'Pokemons', path: '/pokemons' }
  ]
}


export { navConfig }
